module.exports = __webpack_public_path__ + "static/media/pointer-right.2a2bcae7.svg";